<template>
  <div>
    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="ผู้ใช้งานระบบ"
        class="px-5 py-3"
      >
        <v-card class="pa-2" outlined>
          <v-row no-gutters>
            <v-col cols="12" md="4" class="text-right">
              <v-select
                v-model="userstatus_select"
                @change="search_userstatus()"
                label="กลุ่มผู้ใช้งาน"
                filled
                :items="group_userstatus"
                item-text="user_status_name"
                item-value="user_status"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              
            </v-col>
            <v-col cols="12" md="4" class="text-right" v-if="user_id.userauthority_govem != '1' && user_id.userauthority_govem != 1">
              <v-btn
                large
                right
                depressed
                color="primary"
                @click.native="userAdd()"
              >
                <v-icon>mdi-plus-circle-outline</v-icon>เพิ่มรายการ
              </v-btn>


              <v-btn
                large
                right
                depressed
                color="info"
                href="#/admin/print_usersystem"
                target="_blank" 
              >
                <v-icon>mdi-printer</v-icon>ส่งออกข้อมูล
              </v-btn>


            </v-col>
          </v-row>
        </v-card>

        <v-row class="mt-1 mb-1">
          <v-col cols="12" md="6">
            <v-card outlined class="pa-3">
              <div class="subtitle-1 font-weight-medium mb-2">สัดส่วนประเภทผู้ใช้งาน</div>
              <apexchart
                type="donut"
                height="280"
                :options="userStatusChartOptions"
                :series="userStatusChartSeries"
              ></apexchart>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card outlined class="pa-3">
              <div class="subtitle-1 font-weight-medium mb-2">จำนวนผู้ใช้ที่มีสิทธิ์แต่ละประเภท</div>
              <apexchart
                type="bar"
                height="280"
                :options="authorityChartOptions"
                :series="authorityChartSeries"
              ></apexchart>
            </v-card>
          </v-col>
        </v-row>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
          single-line
          hide-details
          dense
          filled
          class="mb-2"
        />
        <v-data-table
          color="success"
          :loading="loading"
          :headers="filteredHeaders"
          :items="users"
          :search="search"
        >
          <template v-slot:item.user_status="{ item }">
            <v-chip v-if="item.user_status === 'B'" color="green" dark
              >สถานศึกษา</v-chip
            >
            <v-chip v-else-if="item.user_status === 'A'" color="info" dark
              >ผู้ดูแลระบบ</v-chip
            >
            <v-chip v-else-if="item.user_status === 'G'" color="pink" dark
              >สอจ.</v-chip
            >
            <v-chip v-else-if="item.user_status === 'C'" color="warning" dark
              >สถาบัน</v-chip
            >
            <v-chip v-else-if="item.user_status === 'S'" color="purple" dark
              >ศูนย์ส่งเสริมและพัฒนาอาชีวศึกษา</v-chip
            >
            <v-chip v-else>ไม่ได้กำหนด</v-chip>
          </template>

          <template v-slot:item.LoginAdmin="{ item }">
            <v-icon
              color="info"
              @click="userLogin(item.user_ID)"
            >
              mdi-puzzle
            </v-icon>
          </template>

          <template v-slot:item.user_statusonoff="{item}">
            <div>
              <v-icon
                v-if="item.user_statusonoff==='1' || item.user_statusonoff === 1"
                color="grey"
                style="cursor: pointer;"
                @click="toggleUserStatusOnOff(item)"
                >mdi-lightbulb</v-icon
              >
              <v-icon
                v-else
                color="success"
                style="cursor: pointer;"
                @click="toggleUserStatusOnOff(item)"
                >mdi-lightbulb-on</v-icon
              >
            </div>
          </template>


          <template v-slot:item.user_update="{item}">
            <div>
              <v-icon v-if="item.user_update==='0' || item.user_update === 0" color="grey">mdi-lightbulb</v-icon>
              <v-icon v-else-if="item.user_update==='1' || item.user_update === 1" color="success">mdi-lightbulb-on</v-icon>
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon color="yellow" @click.stop="userEdit(item.user_ID)">
              mdi-pencil
            </v-icon>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="deep-purple"
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="openResetPassword(item)"
                >
                  mdi-lock-reset
                </v-icon>
              </template>
              <span>รีเซ็ตรหัสผ่าน</span>
            </v-tooltip>
          </template>
          <template v-slot:item.action_s="{ item }">
            <v-icon color="red" @click.stop="userDelete(item.user_ID)">
              mdi-delete
            </v-icon>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
            >ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.</v-alert
          >
        </v-data-table>
      </base-material-card>

      <!--adduserdialog  -->
      <v-layout row justify-center>
        <v-dialog v-model="adduserdialog" persistent max-width="50%">
          <v-card class="mx-auto pa-5">
            <base-material-card
              icon="mdi-account-multiple"
              title="เพิ่มข้อมูลสมาชิก"
              class="px-5 py-3 text_google"
            >
            </base-material-card>

            <v-card-text>
              <v-form ref="adduserform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md6>
                      <v-select
                        outlined
                        :items="userstatus"
                        item-text="user_status_name"
                        item-value="user_status_sub"
                        v-model="adduser.user_status"
                        label="User Type"
                        required
                        :rules="[v => !!v || 'กรุณาเลือกประเภทผู้ใช้']"
                      ></v-select>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field
                        outlined
                        label="Username"
                        v-model="adduser.user_name"
                        required
                        :rules="[v => !!v || 'กรุณากรอกชื่อผู้ใช้']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field
                        outlined
                        label="Password (อย่างน้อย 8 ตัวอักษร มีตัวอักษรและตัวเลข)"
                        v-model="adduser.user_password"
                        type="password"
                        :rules="passwordRules()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field
                        outlined
                        label="Confirm Password"
                        v-model="adduser.user_confirmpassword"
                        type="password"
                        :rules="confirmPasswordRules(() => adduser.user_password)"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-divider></v-divider>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field
                        outlined
                        label="Firstname"
                        v-model="adduser.user_firstname"
                        require
                        :rules="[v => !!v || 'กรุณากรอกชื่อ']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field
                        outlined
                        label="Lastname"
                        v-model="adduser.user_lastname"
                        required
                        :rules="[v => !!v || 'กรุณากรอกนามสกุล']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 v-if="adduser.user_status == 'B'">
                      <v-autocomplete
                        outlined
                        :items="colleges"
                        item-text="college_name"
                        item-value="college_ID"
                        v-model="adduser.college_ID"
                        label="College"
                        required
                        :rules="[v => !!v || 'กรุณาเลือกวิทยาลัย']"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12>
                      <v-autocomplete
                        v-model="adduser.province_ID"
                        outlined
                        :items="provinces"
                        item-text="province_name"
                        item-value="province_ID"
                        label="จังหวัด"
                      ></v-autocomplete>
                    </v-flex>
                    <hr />
                  </v-layout>
                  <h3>สิทธิ์ในการใช้งานระบบ</h3>
                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="adduser.userauthorityAdmin"
                        value="1"
                        label="ผู้ดูแลระบบ"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="adduser.userauthorityMoveTeach"
                        value="1"
                        label="ย้ายสายการสอน"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="adduser.userauthorityMoveManage"
                        value="1"
                        label="ย้ายสายบริหาร"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="adduser.userauthorityManpower"
                        value="1"
                        label="อัตรากำลัง"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="adduser.userauthorityAssitantTeach"
                        value="1"
                        label="ประเมินครูผู้ช่วย"
                      ></v-checkbox>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="adduser.userauthority_govem"
                        value="1"
                        label="พนักงานราชการ"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="adduser.userauthorityAssessSedirector"
                        value="1"
                        label="คัดเลือกรองผู้อำนวยการ"
                      ></v-checkbox>
                    </v-col>

                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="warning"
                large
                @click.stop="adduserdialog = false"
                rounded
                ><v-icon dark>mdi-close</v-icon> ยกเลิก</v-btn
              >
              <v-btn
                large
                color="success"
                @click.stop="adduserSubmit()"
                rounded
              >
                <v-icon dark>mdi-content-save</v-icon>&nbsp;&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model deleteuserdialog -->
      <v-layout>
        <v-dialog v-model="deleteuserdialog" persistent max-width="40%">
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="error"
              icon="mdi-delete"
              title="ลบข้อมูลผู้ใช้"
              class="px-5 py-3 text_google"
            >
            </base-material-card>

            <v-card-text class="text_google">
              <v-card>
                <v-card-text>
                  <v-form ref="deleteuserform" lazy-validation>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                          ยืนยันการลบข้อมูลผู้ใช้ {{ edituser.user_name }}
                          <span v-if="edituser.college_name">{{
                            edituser.college_name
                          }}</span>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="deleteuserdialog = false"
                ><v-icon dark>mdi-close</v-icon>ยกเลิก</v-btn
              >
              <v-btn
                large
                color="red darken-3"
                @click.stop="deleteuserSubmit()"
                dark
              >
                <v-icon dark>mdi-delete</v-icon>&nbsp;ลบ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model edituserdialog -->
      <v-layout row justify-center>
        <v-dialog v-model="edituserdialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="yellow"
              icon="mdi-clipboard-text"
              title="แก้ไขข้อมูลผู้ใช้งานระบบ"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="edituserform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md6>
                      <v-select
                        outlined
                        :items="userstatus"
                        item-text="user_status_name"
                        item-value="user_status_sub"
                        v-model="edituser.user_status"
                        label="User Type"
                        required
                        :rules="[v => !!v || 'กรุณาเลือกประเภทผู้ใช้']"
                      ></v-select>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field
                        outlined
                        label="Username"
                        v-model="edituser.user_name"
                        required
                        :rules="[v => !!v || 'กรุณากรอกชื่อผู้ใช้']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-divider></v-divider>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field
                        outlined
                        label="Firstname"
                        v-model="edituser.user_firstname"
                        require
                        :rules="[v => !!v || 'กรุณากรอกชื่อ']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field
                        outlined
                        label="Lastname"
                        v-model="edituser.user_lastname"
                        required
                        :rules="[v => !!v || 'กรุณากรอกนามสกุล']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 v-if="edituser.user_status == 'B'">
                      <v-autocomplete
                        outlined
                        :items="colleges"
                        item-text="college_name"
                        item-value="college_ID"
                        v-model="edituser.college_ID"
                        label="College"
                        required
                        :rules="[v => !!v || 'กรุณาเลือกวิทยาลัย']"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12>
                      <v-autocomplete
                        v-model="edituser.province_ID"
                        outlined
                        :items="provinces"
                        item-text="province_name"
                        item-value="province_ID"
                        label="จังหวัด"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                  <h3>สิทธิ์ในการใช้งานระบบ</h3>
                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="edituser.userauthorityAdmin"
                        value="1"
                        label="ผู้ดูแลระบบ"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="edituser.userauthorityMoveTeach"
                        value="1"
                        label="ย้ายสายการสอน"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="edituser.userauthorityMoveManage"
                        value="1"
                        label="ย้ายสายบริหาร"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="edituser.userauthorityManpower"
                        value="1"
                        label="อัตรากำลัง"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="edituser.userauthorityAssitantTeach"
                        value="1"
                        label="ประเมินครูผู้ช่วย"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="edituser.userauthorityAssessSedirector"
                        value="1"
                        label="คัดเลือกรองผู้อำนวยการ"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="edituser.userauthority_govem"
                        value="1"
                        label="พนักงานราชการ"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
                <small>* จำเป็น</small>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="edituserdialog = false" rounded>
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="warning"
                @click.stop="edituserSubmit()"
                rounded
              >
                <v-icon dark>mdi-pencil</v-icon>&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model resetPasswordDialog -->
      <v-layout row justify-center>
        <v-dialog v-model="resetPasswordDialog" persistent max-width="450px">
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="deep-purple"
              icon="mdi-lock-reset"
              title="รีเซ็ตรหัสผ่าน"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <p class="mb-4">
                ยืนยันรีเซ็ตรหัสผ่านของ
                <strong>{{ resetPasswordTarget.user_name }}</strong>
                ({{ resetPasswordTarget.user_firstname }}
                {{ resetPasswordTarget.user_lastname }})
              </p>

              <v-text-field
                outlined
                readonly
                label="รหัสผ่านใหม่ที่สุ่มได้"
                v-model="generatedPassword"
                append-icon="mdi-content-copy"
                @click:append="copyResetPassword()"
              ></v-text-field>
              <v-btn
                text
                small
                color="deep-purple"
                @click="generatedPassword = generateRandomPassword()"
              >
                <v-icon left small>mdi-refresh</v-icon>สุ่มรหัสผ่านใหม่
              </v-btn>

              <v-alert
                v-if="resetPasswordDone"
                type="success"
                dense
                outlined
                class="mt-4"
              >
                ดำเนินการรีเซ็ตรหัสผ่านเรียบร้อย กรุณาคัดลอกรหัสผ่านนี้ไปแจ้งผู้ใช้งาน
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="resetPasswordDialog = false" rounded>
                <v-icon dark>mdi-close</v-icon>{{ resetPasswordDone ? "ปิด" : "ยกเลิก" }}
              </v-btn>
              <v-btn
                v-if="!resetPasswordDone"
                large
                color="deep-purple"
                dark
                @click.stop="confirmResetPassword()"
                rounded
              >
                <v-icon dark>mdi-check</v-icon>&nbsp;ยืนยันรีเซ็ต
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>
          {{ snackbar.text }}
        </v-card-text>

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import { passwordRules, confirmPasswordRules } from "@/utils/passwordRules";

export default {
  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      valid: true,
      adduserdialog: false,
      edituserdialog: false,
      deleteuserdialog: false,
      resetPasswordDialog: false,
      resetPasswordDone: false,
      resetPasswordTarget: {},
      generatedPassword: "",
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      users: [],
      user:[],
      adduser: {},
      edituser: {},
      search: "",
      headers: [
      { text: "Login", align: "left", value: "LoginAdmin" },
        { text: "ลำดับ", align: "center", value: "user_ID" },
        { text: "ชื่อผู้ใช้งาน", align: "left", value: "user_name" },
        { text: "เบอร์โทร", align: "center", value: "user_tel_p" },
        { text: "E-mail", align: "center", value: "user_email" },
        { text: "สถานะ", align: "left", value: "user_status" },
        { text: "ชื่อ/สถานศึกษา", align: "left", value: "user_firstname" },
        { text: "นามสกุล/บุคคล", align: "left", value: "user_lastname" },
        { text: "จังหวัด", align: "left", value: "province_name" },
        { text: "On/Off", align: "left", value: "user_statusonoff" },
        { text: "Update", align: "left", value: "user_update" },
        { text: "Latest", align: "left", value: "user_update_date" },
        { text: "สิทธิ์", align: "left", value: "authoritys" },
     
        {
          text: "แก้ไข",
          align: "center",
          value: "actions",
          icon: "mdi-file-document-edit"
        },
        {
          text: "ลบ",
          align: "center",
          value: "action_s",
          icon: "mdi-delete-forever"
        }
      ],
      colleges: [],
      provinces: [],
      userstatus: [],
      data_syslog: {},
      group_userstatus: [],
      userstatus_select: "",
      user_id:[],
    };
  },

  async mounted() {
    try {
      let result = await this.$http.post("college.php", {
        ApiKey: this.ApiKey
      });
      this.colleges = result.data;

      result = await this.$http.post("province.php", {
        ApiKey: this.ApiKey
      });
      this.provinces = result.data;

      await this.userQueryAll();

      let user_status_result = await this.$http.post(
        "crud_user_status.php?crud=read",
        {
          ApiKey: this.ApiKey
        }
      );
      this.userstatus = user_status_result.data;
      await this.groupUserstatus();
      await this.userQueryID();
    } catch (error) {
      console.error("user.vue mounted error:", error);
      Swal.fire({
        icon: "error",
        title: "โหลดข้อมูลเริ่มต้นไม่สำเร็จ กรุณาโหลดหน้าใหม่",
        showConfirmButton: false,
        timer: 2000
      });
    }
  },
  methods: {
    passwordRules,
    confirmPasswordRules,

    async userQueryID() {
      try {
        let userSession = JSON.parse(localStorage.getItem("user")) || 0;
        let result = await this.$http.post("user.php", {
          ApiKey: this.ApiKey,
          user_ID: userSession.user_ID
        });
        this.user_id = result.data;
      } catch (error) {
        console.error("userQueryID error:", error);
      }
    },

    async search_userstatus() {
      try {
        let result = await this.$http.post("user.php", {
          ApiKey: this.ApiKey,
          user_status: this.userstatus_select
        });
        this.users = result.data;
      } catch (error) {
        console.error("search_userstatus error:", error);
        Swal.fire({
          icon: "error",
          title: "ค้นหาไม่สำเร็จ กรุณาลองใหม่",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },
    async groupUserstatus() {
      try {
        let result = await this.$http.post("user.php", {
          ApiKey: this.ApiKey,
          group_userstatus: "ok"
        });
        this.group_userstatus = result.data;
      } catch (error) {
        console.error("groupUserstatus error:", error);
      }
    },
    // ใช้ user_ID ตรงๆ แทนการส่ง user_password (hash) กลับไปเทียบกับตัวเอง —
    // ของเดิมส่ง hash ที่หลุดมาจาก user.php ไปเป็น "รหัสผ่าน" ให้ login.php?crud=admin
    // ซึ่งผ่านเสมอเพราะเทียบ hash กับ hash ตัวเอง (ดูรายละเอียดใน login.php)
    async userLogin(user_ID) {
      try {
        let result = await this.$http.post(
          "login.php?crud=adminImpersonateUser",
          {
            ApiKey: this.ApiKey,
            user_ID: user_ID
          }
        );
        const user = result.data;
        if (user && user.user_status && user.user_status !== "Fail") {
          user.system_lock = false;
          localStorage.setItem("user", JSON.stringify(user));
          if (user.user_status == "A") {
            this.$router.push("/admin");
          } else if (user.user_status == "B") {
            this.$router.push("/college");
          } else if (user.user_status == "C") {
            this.$router.push("/iven");
          } else if (user.user_status == "S") {
            this.$router.push("/supervisions");
          } else if (user.user_status == "D") {
            this.$router.push("/personnel");
          } else if (user.user_status == "G") {
            this.$router.push("/vecprovince");
          } else {
            localStorage.clear();
            Swal.fire({
              icon: "warning",
              title: "ไม่รองรับประเภทผู้ใช้นี้",
              showConfirmButton: false,
              timer: 1500
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "ไม่พบบัญชีผู้ใช้ หรือเข้าสู่ระบบแทนไม่สำเร็จ",
            showConfirmButton: false,
            timer: 1500
          });
        }
      } catch (error) {
        console.error("userLogin error:", error);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },
    async userQueryAll() {
      this.loading = true;
      try {
        let result = await this.$http
          .post("user.php", {
            ApiKey: this.ApiKey,
            admin: "ok"
          })
          .finally(() => (this.loading = false));
        this.users = result.data;
      } catch (error) {
        console.error("userQueryAll error:", error);
        Swal.fire({
          icon: "error",
          title: "โหลดรายชื่อผู้ใช้ไม่สำเร็จ",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },
    async toggleUserStatusOnOff(item) {
      try {
        const isOn =
          item.user_statusonoff === "1" || item.user_statusonoff === 1;
        const newValue = isOn ? "0" : "1";
        let result = await this.$http.post("user.update.php", {
          ApiKey: this.ApiKey,
          user_ID: item.user_ID,
          user_statusonoff: newValue
        });
        if (result.data && result.data.status) {
          item.user_statusonoff = newValue;
        } else {
          Swal.fire({
            icon: "warning",
            title: "เปลี่ยนสถานะไม่สำเร็จ",
            showConfirmButton: false,
            timer: 1500
          });
        }
      } catch (error) {
        console.error("toggleUserStatusOnOff error:", error);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },
    async userAdd() {
      this.adduser = {};
      this.adduserdialog = true;
    },
    async adduserSubmit() {
      if (this.$refs.adduserform.validate()) {
        try {
          this.adduser.ApiKey = this.ApiKey;
          // backend (user.insert.php) อ่าน user_college_ID/user_province_ID ไม่ใช่
          // college_ID/province_ID ที่ v-model ผูกไว้ — ถ้าไม่ map ชื่อ field ให้ตรง
          // ค่าที่เลือกไว้จะไม่ถูกบันทึกโดยไม่มีข้อความแจ้งอะไรเลย
          this.adduser.user_college_ID = this.adduser.college_ID;
          this.adduser.user_province_ID = this.adduser.province_ID;
          let result = await this.$http.post("user.insert.php", this.adduser);
          if (result.data.status == true) {
            this.user = result.data;
            Swal.fire({
              icon: "success",
              title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
            this.userQueryAll();
            let userSession = JSON.parse(localStorage.getItem("user")) || 0;
            this.data_syslog.ApiKey = this.ApiKey;
            this.data_syslog.user_account = userSession.user_name;
            this.data_syslog.event_log = "insert";
            this.data_syslog.page_log = "user";
            this.data_syslog.table_log = "user";
            this.data_syslog.detail_log =
              this.adduser.user_name + " : " + this.adduser.user_status;
            this.data_syslog.date_times = this.date_today_log;
            await this.$http.post("data_syslog.insert.php", this.data_syslog);
          } else {
            Swal.fire({
              icon: "warning",
              title: "ดำเนินการผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
            this.userQueryAll();
          }
          this.adduserdialog = false;
        } catch (error) {
          console.error("adduserSubmit error:", error);
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่",
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
    },
    async userEdit(user_ID) {
      try {
        let result = await this.$http.post("user.php", {
          ApiKey: this.ApiKey,
          user_ID: user_ID
        });
        this.edituser = result.data;
        this.edituserdialog = true;
      } catch (error) {
        console.error("userEdit error:", error);
        Swal.fire({
          icon: "error",
          title: "โหลดข้อมูลผู้ใช้ไม่สำเร็จ",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },

    // ══════════════════════════════════════════════════════════════════
    // Reset รหัสผ่าน — แยกออกจากฟอร์มแก้ไขทั่วไป สุ่มรหัสผ่านให้อัตโนมัติ
    // ══════════════════════════════════════════════════════════════════
    generateRandomPassword() {
      // ตัดอักขระที่สับสนง่ายเวลาพิมพ์ตาม (0/O, 1/l/I) ออก และใช้ crypto.getRandomValues
      // แทน Math.random() เพื่อความสุ่มที่ปลอดภัยกว่าสำหรับใช้เป็นรหัสผ่าน
      const chars =
        "ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789";
      const length = 12;
      const randomValues = new Uint32Array(length);
      window.crypto.getRandomValues(randomValues);
      let pwd = "";
      for (let i = 0; i < length; i++) {
        pwd += chars[randomValues[i] % chars.length];
      }
      return pwd;
    },
    openResetPassword(item) {
      this.resetPasswordTarget = item;
      this.generatedPassword = this.generateRandomPassword();
      this.resetPasswordDone = false;
      this.resetPasswordDialog = true;
    },
    async copyResetPassword() {
      try {
        await navigator.clipboard.writeText(this.generatedPassword);
        Swal.fire({
          icon: "success",
          title: "คัดลอกรหัสผ่านแล้ว",
          showConfirmButton: false,
          timer: 1000
        });
      } catch (error) {
        console.error("copyResetPassword error:", error);
      }
    },
    async confirmResetPassword() {
      try {
        let result = await this.$http.post("user.update.php", {
          ApiKey: this.ApiKey,
          user_ID: this.resetPasswordTarget.user_ID,
          user_password: this.generatedPassword
        });
        if (result.data && result.data.status) {
          this.resetPasswordDone = true;
          let userSession = JSON.parse(localStorage.getItem("user")) || 0;
          await this.$http.post("data_syslog.insert.php", {
            ApiKey: this.ApiKey,
            user_account: userSession.user_name,
            event_log: "reset_password",
            page_log: "user",
            table_log: "user",
            detail_log:
              "รีเซ็ตรหัสผ่านให้ " + this.resetPasswordTarget.user_name,
            date_times: this.date_today_log
          });
          this.userQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "รีเซ็ตรหัสผ่านไม่สำเร็จ",
            showConfirmButton: false,
            timer: 1500
          });
        }
      } catch (error) {
        console.error("confirmResetPassword error:", error);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },
    async edituserSubmit() {
      if (this.$refs.edituserform.validate()) {
        try {
          this.edituser.ApiKey = this.ApiKey;
          // รหัสผ่านแยกไปจัดการผ่าน dialog "รีเซ็ตรหัสผ่าน" (confirmResetPassword) แล้ว
          // ฟอร์มนี้จึงไม่ส่ง user_password เลย ไม่กระทบรหัสผ่านเดิม
          delete this.edituser.user_password;
          // map ชื่อ field ให้ตรงกับที่ user.update.php อ่าน (ดูหมายเหตุใน adduserSubmit)
          this.edituser.user_college_ID = this.edituser.college_ID;
          this.edituser.user_province_ID = this.edituser.province_ID;
          let result = await this.$http.post("user.update.php", this.edituser);
          if (result.data.status == true) {
            this.user = result.data;
            Swal.fire({
              icon: "success",
              title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
            this.userQueryAll();
            let userSession = JSON.parse(localStorage.getItem("user")) || 0;
            this.data_syslog.ApiKey = this.ApiKey;
            this.data_syslog.user_account = userSession.user_name;
            this.data_syslog.event_log = "update";
            this.data_syslog.page_log = "user";
            this.data_syslog.table_log = "user";
            this.data_syslog.detail_log =
              this.edituser.user_name + " : " + this.edituser.user_status;
            this.data_syslog.date_times = this.date_today_log;
            await this.$http.post("data_syslog.insert.php", this.data_syslog);
          } else {
            Swal.fire({
              icon: "warning",
              title: "ดำเนินการผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
          this.edituserdialog = false;
        } catch (error) {
          console.error("edituserSubmit error:", error);
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่",
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
    },
    async userDelete(user_ID) {
      try {
        let result = await this.$http.post("user.php", {
          ApiKey: this.ApiKey,
          user_ID: user_ID
        });
        this.edituser = result.data;
        this.deleteuserdialog = true;
      } catch (error) {
        console.error("userDelete error:", error);
        Swal.fire({
          icon: "error",
          title: "โหลดข้อมูลผู้ใช้ไม่สำเร็จ",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },
    async deleteuserSubmit() {
      if (this.$refs.deleteuserform.validate()) {
        try {
          this.edituser.ApiKey = this.ApiKey;
          if (this.edituser.user_status == "D")
            await this.$http.post("committee.delete.php", {
              ApiKey: this.ApiKey,
              user_ID: this.edituser.user_ID
            });
          let result = await this.$http.post("user.delete.php", this.edituser);
          if (result.data.status == true) {
            this.user = result.data;
            Swal.fire({
              icon: "success",
              title: "ดำเนินการลบข้อมูลเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
            this.userQueryAll();
            let userSession = JSON.parse(localStorage.getItem("user")) || 0;
            this.data_syslog.ApiKey = this.ApiKey;
            this.data_syslog.user_account = userSession.user_name;
            this.data_syslog.event_log = "delete";
            this.data_syslog.page_log = "user";
            this.data_syslog.table_log = "user";
            this.data_syslog.detail_log =
              this.edituser.user_name + " : " + this.edituser.user_status;
            this.data_syslog.date_times = this.date_today_log;
            await this.$http.post("data_syslog.insert.php", this.data_syslog);
          } else {
            Swal.fire({
              icon: "warning",
              title: "ดำเนินการลบผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        } catch (error) {
          console.error("deleteuserSubmit error:", error);
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.deleteuserdialog = false;
      }
    }
  },
  computed: {
    // สัดส่วนประเภทผู้ใช้งาน — ใช้สีชุดเดียวกับ v-chip ในตาราง (ด้านบน) ให้เป็นระบบเดียวกัน
    userStatusChartSeries() {
      const counts = { A: 0, B: 0, G: 0, C: 0, S: 0, other: 0 };
      this.users.forEach(u => {
        if (counts.hasOwnProperty(u.user_status)) counts[u.user_status]++;
        else counts.other++;
      });
      return [counts.A, counts.B, counts.G, counts.C, counts.S, counts.other].filter(
        (v, i) => v > 0 || i < 5
      );
    },
    userStatusChartOptions() {
      const labels = [
        "ผู้ดูแลระบบ",
        "สถานศึกษา",
        "สอจ.",
        "สถาบัน",
        "ศูนย์ส่งเสริมและพัฒนาอาชีวศึกษา",
        "ไม่ได้กำหนด"
      ];
      const colors = ["#2196F3", "#4CAF50", "#E91E63", "#FB8C00", "#9C27B0", "#9E9E9E"];
      const n = this.userStatusChartSeries.length;
      return {
        chart: { type: "donut" },
        labels: labels.slice(0, n),
        colors: colors.slice(0, n),
        legend: { position: "bottom", fontSize: "13px" },
        dataLabels: { enabled: true, formatter: val => val.toFixed(1) + "%" },
        plotOptions: {
          pie: { donut: { labels: { show: true, total: { show: true, label: "รวม" } } } }
        }
      };
    },
    // จำนวนผู้ใช้ที่มีสิทธิ์แต่ละประเภท (นับจาก userauthority* ที่เป็น '1'/1)
    authorityChartSeries() {
      const flags = [
        "userauthorityAdmin",
        "userauthorityMoveTeach",
        "userauthorityMoveManage",
        "userauthorityManpower",
        "userauthorityAssitantTeach",
        "userauthorityAssessSedirector",
        "userauthority_govem"
      ];
      const counts = flags.map(
        f => this.users.filter(u => u[f] === "1" || u[f] === 1).length
      );
      return [{ name: "จำนวนผู้ใช้", data: counts }];
    },
    authorityChartOptions() {
      const categories = [
        "ผู้ดูแลระบบ",
        "ย้ายสายการสอน",
        "ย้ายสายบริหาร",
        "อัตรากำลัง",
        "ประเมินครูผู้ช่วย",
        "คัดเลือกรองผอ.",
        "พนักงานราชการ"
      ];
      const colors = ["#1976D2", "#388E3C", "#F57C00", "#D32F2F", "#7B1FA2", "#0097A7", "#5D4037"];
      return {
        chart: { type: "bar", toolbar: { show: false } },
        plotOptions: { bar: { distributed: true, borderRadius: 4, horizontal: false } },
        colors,
        xaxis: {
          categories,
          labels: { style: { fontSize: "11px" } }
        },
        legend: { show: false },
        dataLabels: { enabled: true }
      };
    },
    filteredHeaders() {
      if (this.user_id.userauthority_govem === "1") {
        // ซ่อนคอลัมน์ actions และ action_s
        return this.headers.filter(
          h => h.value !== "actions" && h.value !== "action_s" && h.value !== "authoritys"
        );
      }
      return this.headers;
    },

    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear() + 543;
      let time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      today = dd + "/" + mm + "/" + yyyy + "/" + time;
      return today;
    }
  }
};
</script>
